'use client'

import { useSelector } from 'react-redux'
import type { IRedux } from '../_store/types'
import { useCustomLocale } from './useCustomLocale'
import {
  mapWebSiteLanguageCodes,
  resolveLocaleField,
} from '../_utils/resolve-locale-field'

export function useWebsiteLanguageCodes(): string[] {
  const settings = useSelector((state: IRedux) => state.settings)
  return mapWebSiteLanguageCodes(settings?.data?.data?.web_site_languages)
}

/** Client helper: preferred locale → web_site_languages → first non-empty. */
export function useResolveLocaleField() {
  const locale = useCustomLocale()
  const fallbackLocales = useWebsiteLanguageCodes()

  return (
    field: Record<string, string> | null | undefined,
    fallback = ''
  ): string => resolveLocaleField(field, locale, fallbackLocales, fallback)
}
